import { useEffect } from 'react';
import { useRefGetter, useUpdate } from '@okee-uikit/react-hooks';
import { useCascader } from './useCascader';
export function useCascaderItem(id) {
  var cascader = useCascader();
  var idGetter = useRefGetter(id);
  var update = useUpdate();
  var info = cascader.getItemInfo(id) || {};
  var stateGetter = useRefGetter(info.state);
  useEffect(function () {
    var loadingCallback = function loadingCallback(cid) {
      if (cid !== idGetter()) {
        return;
      }

      update();
    };

    var changeCallback = function changeCallback() {
      if (info.state === stateGetter()) {
        return;
      }

      update();
    };

    cascader.addListener('value-change', changeCallback);
    cascader.addListener('data-loading', loadingCallback);
    cascader.addListener('reset', update);
    return function () {
      cascader.removeListener('value-change', changeCallback);
      cascader.removeListener('data-loading', loadingCallback);
      cascader.removeListener('reset', update);
    };
  }, []);
  return info;
}